<div class="MainContainer">

    <div class="MainTitleBar">
        <p class="SectionHalfTitle" style="margin-top: 0%;">
            <i class="material-icons SectionHalfTitleIcon">history_toggle_off</i>
            <span>{{ 'ActivityLog' | translate }}</span>
        </p>
        <div class="SectionHalfTitle SectionHalfTitleRight">
          <button (click)="ExportActivityLog();" style="padding-left: 10px;background:#32aa3a;" mat-raised-button color="primary"><i class="material-icons">file_download</i> {{'Export' | translate}}</button>
        </div>
    </div>

    <div class="MainTitleBar" style="overflow: hidden;">
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
            <mat-label>{{ 'Receptions.ChoosePeriod' | translate }}</mat-label>
            <mat-select name="Administration" [(ngModel)]="Filter.Period">
              <mat-option *ngFor="let a of this.Periods;" [value]="a" (click)="AddActiveFilter(a.Name, 'Period'); GetLogsFiltered();">
                {{a.Name}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.FromDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp" [formControl]="FromDate" [(ngModel)]="Filter.FromDate" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
            <mat-datepicker #dp></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="MainTitleBarIconContainer">
          <i class="material-icons">date_range</i>
        </div>
      
        <div class="FifteenPercentContainer">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'Receptions.ToDate' | translate }}</mat-label>
            <input matInput [matDatepicker]="dp1" [formControl]="ToDate" [(ngModel)]="Filter.ToDate" (click)="DisablePeriod();" (dateChange)="ClearPeriod()">
            <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
            <mat-datepicker #dp1></mat-datepicker>
          </mat-form-field>
        </div>
      
        <div class="FifteenPercentContainer" style="margin-top: -4px;">
            <button mat-mini-fab aria-label="Example icon button with a home icon" color="primary" (click)="GetLogsFiltered();">
              <mat-icon>filter_alt</mat-icon>
            </button>
        </div>
      
    </div>

    <div class="MainTitleBar" style="overflow: unset;">
    
        <div class="FilterButton noselect" (click)="this.showFilter = !this.showFilter;">
            <i class="material-icons">filter_alt</i>
            <span>Filter</span>
        </div>

        <div class="ActiveFiltersContainer">
          <div class="ActiveFilter" *ngFor="let a of this.activeFilters;" (click)="RemoveActiveFilter(a.ID, a.Type);">
            {{a.Name}}
            <i class="material-icons">close</i>
          </div>
        </div>

        <div class="FilterContainer animated fadeIn" *ngIf="showFilter">
            <div class="FilterCloseContainer" (click)="this.showFilter = false;">
                <i class="material-icons">close</i>
            </div>
    
            <div class="FilterContainerBody">
    
                <div class="PopUpBodyRow">
                  <div class="PopUpBodyTwoThirdsContainer">
                  <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                      <mat-label>{{ 'Company' | translate }}</mat-label>
                      <mat-select name="Company" [(ngModel)]="Filter.Company">
                        <mat-option *ngFor="let c of this.Companies;" [value]="c" (click)="AddActiveFilter(c.Name, 'Company');">
                          {{c.Name}}
                        </mat-option>
                      </mat-select>
                    </mat-form-field>
                  </div>

                  <div class="PopUpBodyOneThirddContainer"></div>
                </div>
    
                <div class="PopUpBodyOneThirddContainer">
                      <mat-form-field appearance="outline" class="ReceptionProductsColDropDown">
                        <mat-label>{{ 'UserName' | translate }}</mat-label>
                        <input matInput placeholder="{{ 'UserName' | translate }}" autocomplete="off" [(ngModel)]="Filter.Product" (change)="AddActiveFilter(Filter.Product, 'Product');">
                      </mat-form-field>
                </div>
                
                <div class="PopUpBodyTwoThirdsContainer">
                    <mat-form-field class="ReceptionProductsColDropDown" appearance="outline">
                        <mat-label>{{ 'EventType' | translate }}</mat-label>
                        <mat-select name="EventType" [(ngModel)]="Filter.Type">
                          <mat-option *ngFor="let t of this.LogEvents;" [value]="t" (click)="AddActiveFilter(t.Name, 'EventType');">
                            {{t.Name}}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                </div>
              
            </div>
            
            <div class="FilterCommands">
                <button mat-raised-button color="primary" class="FilterButtonAction" (click)="GetLogsFiltered();">{{ 'FilterInvoices' | translate }}</button>
            </div>
        </div>

        <div class="TotalDocCountContainer">
          <span style="float: right;">{{this.Logs.length}} {{'OfWord' | translate}} {{this.Filter.Pager.TotalCount}} {{'Logs' | translate}} ({{'Page' | translate}}: {{this.Filter.Pager.PageIndex}} {{'OfWord' | translate}} {{this.Filter.Pager.Pages}})</span>
          <div class="PageSizeContainer">
            <mat-form-field appearance="outline" class="PageSizeTextBox">
              <mat-label>{{ 'PageSize' | translate }}*</mat-label>
              <input matInput autocomplete="off" [(ngModel)]="Filter.Pager.PageSize" (change)="GetLogsFiltered(1);">
            </mat-form-field>
          </div>
        </div>

        <div class="TotalDocCountContainer">
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != 1;" (click)="GetLogsFiltered(this.Filter.Pager.PageIndex - 1);">
            <i class="material-icons">chevron_left</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == 1;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_left</i>
          </div>

          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex != this.Filter.Pager.Pages;" (click)="GetLogsFiltered(this.Filter.Pager.PageIndex + 1);">
            <i class="material-icons">chevron_right</i>
          </div>
          <div class="TopPagingButton unSelectable" *ngIf="this.Filter.Pager.PageIndex == this.Filter.Pager.Pages;" style="background: #eee;columns: #aaa;cursor: not-allowed;">
            <i class="material-icons">chevron_right</i>
          </div>
        </div>
    </div>

    <div class="MainBody">

        <div class="ReceptionProductsContainer">
          
            <div class="ReceptionProductsHeadder ReceptionProductsRow" style="border: none;">
                <div class="ReceptionProductsCol" style="width: 2.5%;">
                    {{ 'Receptions.Table.Nr' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 7.5%;">
                  {{ 'Company' | translate }}
              </div>
                <div class="ReceptionProductsCol" style="width: 15%;">
                  {{ 'UserName' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 15%;text-align: left;padding-left: 1%;">
                  {{ 'Email' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 10%;">
                  {{ 'EventRegister' | translate }}
                </div>
                <div class="ReceptionProductsCol" style="width: 30%;">
                    {{ 'Description' | translate }}
                  </div>
                <div class="ReceptionProductsCol" style="width: 20%;">
                  {{ 'Observations' | translate }}
                </div>
            </div>
    
            <div class="ReceptionProductsRow TotalRow" *ngIf="this.loading">
                <mat-spinner class="smallSpinner" [diameter]="30"></mat-spinner>
            </div>
            <div *ngIf="!this.loading">
               <div class="ReceptionProductsRow ReceptionProductsRowHover" *ngFor="let log of this.Logs; let j=index;">
                <div class="ReceptionProductsCol DottedRow" style="width: 2.5%;">
                    {{j + 1}}
                </div>
                <div class="ReceptionProductsCol DottedRow" style="width: 7.5%;">
                  {{log.CompanyName}}
              </div>
                <div class="ReceptionProductsCol DottedRow" style="width: 15%;">
                    {{log.Name}}
                </div>
                <div class="ReceptionProductsCol DottedRow" style="width: 15%;text-align: left;padding-left: 1%;">
                    {{log.Email}}
                </div>
                <div class="ReceptionProductsCol DottedRow" style="width: 10%;">
                    {{log.EventRegisterUI}}
                </div>
                <div class="ReceptionProductsCol DottedRow" style="width: 30%;">
                    {{log.Event.Name}}
                  </div>
                <div class="ReceptionProductsCol" style="width: 20%;">
                    <p>{{log.Event.Description}}</p>
                </div>
               </div>
            </div>
        </div>
    </div>
</div>